import React from 'react'

function AboutText() {
  return (
    <div className="about-text">
            I am a software developer who is passionate about using innovation to inspire creativity, improve efficiencies, and support people and planet.
    </div>
  )
}

export default AboutText